//Return array for user menu
export const menu= ()=> {
  return [
    {
      show: true,
      name: "HOME",
      link: "/",
      subMunu: [
        { link: "/" },
        { link: "/" }
      ],
      white_image: "../../assets/images/icons8-home.png",
      blue_image: "../../assets/images/campaingns_sl.png"
    },
    {
      show: true,
      name: "CAMPAIGNS",
      link: "/dashboard",
      subMunu: [
        { link: "/campaign" },
        { link: "/kyc" }
      ],
      white_image: "../../assets/images/campaingns.png",
      blue_image: "../../assets/images/campaingns_sl.png"
    },
    
    {
      show: true,
      name: "KYC DETAILS",
      link: "/kycdetails",
      subMunu: [
        { link: "/updatekycdetails" }
      ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    },
    
    {
      show: true,
      name: "CONTACT US",
      link: "/contactUs",
      subMunu: [],
      white_image: "../../assets/images/telephone.svg",
      blue_image: "../../assets/images/contactus_sl.png"
    }
  ]
}


// WEBPACK FOOTER //
// ./web/menu/user_menu_options.js